import { render } from "./StartAuthComponent.vue?vue&type=template&id=d1575af0&scoped=true"
import script from "./StartAuthComponent.vue?vue&type=script&lang=js"
export * from "./StartAuthComponent.vue?vue&type=script&lang=js"

import "./StartAuthComponent.vue?vue&type=style&index=0&id=d1575af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1575af0"]])

export default __exports__